import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconSyncMediumComponent } from "./med-icon-sync-medium.component";

@NgModule({
  declarations: [
    MedIconSyncMediumComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconSyncMediumComponent,
  ],
})
export class MedIconSyncMediumModule { }
